import { motion, AnimatePresence } from 'framer-motion';
import { HorizontalActivityCarousel } from './index';
import { useInfinitePackActivities } from '../../hooks/usePacks';
import { getPackEmoji } from './packEmojis';
import type { Pack } from '../../types/pack.types';
import libraryDownArrow from '../../../assets/icons/library-down-arrow.svg';
import {
  accordionRowHeight,
  accordionRowPadding,
  accordionPackName,
  accordionArrowSize,
} from './constants';

interface PackAccordionRowProps {
  pack: Pack;
  isExpanded: boolean;
  onToggle: () => void;
}

export default function PackAccordionRow({ pack, isExpanded, onToggle }: PackAccordionRowProps) {
  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useInfinitePackActivities(isExpanded ? pack.id : null, 10);

  const activities = data?.pages.flatMap((p) => p.activities) ?? [];
  const emoji = getPackEmoji(pack.key);

  return (
    <div>
      <button
        onClick={onToggle}
        className={`w-full flex items-center justify-between ${accordionRowHeight} ${accordionRowPadding} rounded-[16px] border-none cursor-pointer`}
        style={{ backgroundColor: '#01A7C8' }}
      >
        <span className={accordionPackName} style={{ fontFamily: 'DM Sans, sans-serif' }}>
          {emoji ? `${emoji} ${pack.name}` : pack.name}
        </span>
        <motion.img
          src={libraryDownArrow}
          alt=""
          animate={{ rotate: isExpanded ? 180 : 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          className={accordionArrowSize}
          style={{ filter: 'brightness(0) invert(1)' }}
        />
      </button>

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{
              height: { duration: 0.3, ease: 'easeOut' },
              opacity: { duration: 0.2, ease: 'easeOut', delay: 0.1 },
            }}
            style={{ overflow: 'hidden' }}
          >
            <div className="pt-3">
              <HorizontalActivityCarousel
                activities={activities}
                isLoading={isLoading}
                hasNextPage={hasNextPage}
                isFetchingNextPage={isFetchingNextPage}
                onLoadMore={fetchNextPage}
                startPadding={4}
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
